module.exports = __webpack_public_path__ + "static/solution5-18d05ee7b5c17519f7ae3237ea8e088f.png";